import { createApiClient } from "../../../shared/lib/createApiClient"

let authToken = null

export const setAuthToken = (token) => {
    authToken = token || null
}

export const clearAuthToken = () => {
    authToken = null
}

export const api = createApiClient()

api.interceptors.request.use((config) => {
    if (authToken) {
        config.headers = config.headers || {}
        if (!config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${authToken}`
        }
    }
    return config
})

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthToken()
            localStorage.removeItem("sgrhome_admin_auth")
        }
        return Promise.reject(error)
    }
)

export async function requestJson(url, { method = "GET", body, headers = {}, expectJson = true } = {}) {
    const isFormData = typeof FormData !== "undefined" && body instanceof FormData
    const finalHeaders = { ...headers }

    // JSON bodies need an explicit type. FormData must omit Content-Type so the
    // browser can set multipart/form-data with the correct boundary — otherwise
    // multer never sees the file ("Image file is required").
    if (body !== undefined && body !== null && !isFormData && !finalHeaders["Content-Type"]) {
        finalHeaders["Content-Type"] = "application/json"
    }

    const config = {
        url,
        method,
        headers: finalHeaders,
    }

    if (body !== undefined && body !== null) {
        config.data = body
    }

    if (isFormData) {
        config.transformRequest = [
            (data, reqHeaders) => {
                if (typeof reqHeaders?.set === "function") {
                    reqHeaders.set("Content-Type", false)
                } else if (reqHeaders) {
                    delete reqHeaders["Content-Type"]
                    delete reqHeaders["content-type"]
                }
                return data
            },
        ]
    }

    try {
        const res = await api(config)
        return expectJson ? res.data : undefined
    } catch (err) {
        if (err.response) {
            const { status, data } = err.response
            if (status === 400) {
                if (typeof data?.error === "string" && Object.keys(data).length === 1) {
                    const error = new Error(data.error)
                    error.status = 400
                    throw error
                }
                const validationErrors =
                    data && typeof data === "object" && !Array.isArray(data) ? data : {}
                const error = new Error("Validation failed")
                error.status = 400
                error.validationErrors = validationErrors
                throw error
            }
            const error = new Error(data?.error || `Request failed with status ${status}`)
            error.status = status
            throw error
        }
        const error = new Error("Network error")
        error.status = 0
        throw error
    }
}
